import { Position, Toaster, Intent } from "@blueprintjs/core";

export { Intent };

export const AppToaster = Toaster.create({
  maxToasts: 1,
  className: "recipe-toaster",
  position: Position.BOTTOM_LEFT
});
